import { SendOtpFieldType } from "../types/CustomerTypes"

export const WeekDays = [
  { label: "Sunday", value: "sunday" },
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
]
export const WeekDaysDefaultValue = WeekDays[0]

export const timeFormatOptions = [
  { label: "12h", value: "12h" },
  { label: "24h", value: "24h" },
]
export const timeFormatDefaultOptions = timeFormatOptions[0]
export const orderNumberFormatOptions = [
  {
    label: "Numeric",
    value: "numeric",
  },
  {
    label: "Alphanumeric",
    value: "alphanumeric",
  },
]
export const AssetCategory = [
  {
    label: "Bus",
    value: "98892591-61d9-4eba-9348-c61eb1518bb5",
  },
  {
    label: "Boat",
    value: "98875e3b-d863-4269-8031-9b2836673f7e",
  },
  {
    label: "Instructor",
    value: "98892591-61d9-4eba-9348-c61eb1518bb5",
  },
  {
    label: "Guide",
    value: "98892591-61d9-4eba-9348-c61eb1518bb5",
  },
]

export const orderNumberFormatDefaultOptions = {
  label: "Sequential",
  value: "sequential",
}

export const showOrderNumberPrefixOn = ["Alphanumeric", "Sequential"]

export const sampleProductItems = [
  {
    label: "AC Room",
    selected: false,
    id: "04e1ce2a-b9f4-40d7-9dd5-feb18cc232a1",
  },
  {
    label: "Party Hall",
    selected: false,
    id: "04e1ce2a-b9f4-40d7-9dd5-feb18cc232a2",
  },
  {
    label: "Boating",
    selected: false,
    id: "04e1ce2a-b9f4-40d7-9dd5-feb18cc232a3",
  },
  {
    label: "Club",
    selected: false,
    id: "04e1ce2a-b9f4-40d7-9dd5-feb18cc232a4",
  },
]

export const CustomersStatusOptions = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
]

export const AffiliateTypeEnum = {
  OFFLINE: "offline",
  PRIVATE: "private",
  STAFF_AFFILIATE: "staff_affiliate",
  AFFILIATE: "affiliate",
}

export const AffiliateCommissionsTypeEnum = {
  PAYABLE: "Payable",
  NOT_PAYABLE: "Not Payable",
}

export const AffiliateStatusTypeEnum = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DRAFT: "draft",
}

export const AffiliateInvitationStatusOptions = [
  {
    label: "Draft",
    value: AffiliateStatusTypeEnum.DRAFT,
  },
]
export const AffiliateStatusOptions = [
  {
    label: "Inactive",
    value: AffiliateStatusTypeEnum.INACTIVE,
  },
  {
    label: "Active",
    value: AffiliateStatusTypeEnum.ACTIVE,
  },
]

export const AFFILIATE_TYPE = [
  {
    label: "New Affiliate",
    value: AffiliateTypeEnum.AFFILIATE,
  },
  {
    label: "Existing Staff Member",
    value: AffiliateTypeEnum.STAFF_AFFILIATE,
  },
]

export const filterDefaultOptions = {
  from: 0,
  limit: 10,
  page: 1,
}
export const PaginationOption = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
]

export const AssetClosureStatusTypeEnum = {
  ACTIVE: "active",
  PAST: "past",
}

export const WidgetButtonType = [
  {
    label: "Primary",
    value: "primary",
  },
  {
    label: "Link Button",
    value: "link_button",
  },
]

export const WidgetProductDetailPageOptions = [
  {
    label: "Default View",
    value: "default_view",
  },
  {
    label: "With All Details",
    value: "with_all_details",
  },
  {
    label: "Show Photos Only",
    value: "show_photos_only",
  },
]

export const WidgetbuttonSizeOptions = [
  {
    label: "Small",
    value: "xs",
  },
  {
    label: "Regular",
    value: "sm",
  },
  {
    label: "Medium",
    value: "md",
  },
  {
    label: "Large",
    value: "lg",
  },
]

export const WidgetButtonTextStyleOptions = [
  {
    label: "Regular",
    value: "regular",
  },
  {
    label: "Medium",
    value: "medium",
  },
  {
    label: "Bold",
    value: "bold",
  },
]

export const WidgetButtonLinkToOptions = [
  {
    label: "Categories View",
    value: "Categories_view",
  },
  {
    label: "Products View",
    value: "products_view",
  },
  {
    label: "Specific Product",
    value: "specific_product",
  },
  {
    label: "Specific Category",
    value: "specific_category",
  },
]

export const CustomWidgetOptions = [
  {
    label: "Category View",
    value: "category_view",
  },
  {
    label: "Product List",
    value: "product_list",
  },
  {
    label: "Product Details",
    value: "product_details",
  },
  // {
  //   label: "Location View",
  //   value: "location_view",
  // },
]

export const CustomWidgetShowProductList = [
  {
    label: "All Products",
    value: "all_products",
  },
  {
    label: "Specific Category's Products",
    value: "specific_category's_products",
  },
]

export const DisplayCategoryOptions = [
  {
    label: "Tab",
    value: "tab",
  },
  {
    label: "Dropdown",
    value: "dropdown",
  },
]

export const CalendarWidgetOptions = [
  {
    label: "Specific Product",
    value: "specific_Product",
  },
  {
    label: "All Products",
    value: "all_products",
  },
]

export const ShowProductsInCalendarOptions = [
  {
    label: "Show After Date Selection",
    value: "show_after_date_selection",
  },
  {
    label: "Directly Show in Calendar",
    value: "directly_show_in_calendar",
  },
]

export const steps = [
  {
    label: "Scheduling",
    value: "scheduling",
  },
  {
    label: "Participant & Booking Details",
    value: "participantDetails",
  },
  {
    label: "Additional Products",
    value: "additionalProducts",
  },
  {
    label: "Contact Details",
    value: "contactDetails",
  },
]

export const GiftCardBuySteps = [
  {
    label: "View Details",
    value: "viewDetails",
  },
  {
    label: "Contact Details",
    value: "contactDetails",
  },
]

export const MerchandizeProductBuySteps = [
  {
    label: "View Details",
    value: "viewDetails",
  },
  {
    label: "Contact Details",
    value: "contactDetails",
  },
]

export const BookingCancellationModalActions = {
  ADD: "add",
  UPDATE: "update",
  ADD_WITHOUT_CANCELLING_BOOKINGS: "add_without_cancelling_bookings",
  UPDATE_WITHOUT_CANCELLING_BOOKINGS: "update_without_cancelling_bookings",
  DELETE: "delete",
}

export const AssetClosureActions = {
  ADD: "add",
  UPDATE: "update",
  ADD_WITHOUT_CANCELLING_BOOKINGS: "add_without_cancelling_bookings",
  UPDATE_WITHOUT_CANCELLING_BOOKINGS: "update_without_cancelling_bookings",
}

export const ProductClosureActions = {
  ADD: "add",
  UPDATE: "update",
  ADD_WITHOUT_CANCELLING_BOOKINGS: "add_without_cancelling_bookings",
  UPDATE_WITHOUT_CANCELLING_BOOKINGS: "update_without_cancelling_bookings",
}

export const ProductSchedulingActions = {
  DELETE: "delete",
}

export const PriceSheetStatusTypeEnum = {
  DRAFT: "inactive",
  Active: "active",
}

export const PriceSheetStatusOptions = [
  {
    label: "Draft",
    value: PriceSheetStatusTypeEnum.DRAFT,
  },
  {
    label: "Active",
    value: PriceSheetStatusTypeEnum.Active,
  },
]

export const ProductWaiverAttachmentTypeEnum = {
  Booking: "booking",
  Participant: "participant",
}

export const ProductWaiverAttachmentOptions = [
  {
    label: "Per Booking",
    value: ProductWaiverAttachmentTypeEnum.Booking,
  },
  {
    label: "Per Participant",
    value: ProductWaiverAttachmentTypeEnum.Participant,
  },
]

export const VisibilityTypeEnum = {
  Everyone: "everyone",
  Internal: "internal",
  Member: "member",
}

export const VISIBILITY_TYPE = [
  {
    label: "Everyone",
    value: VisibilityTypeEnum.Everyone,
  },
  {
    label: "Internal Only",
    value: VisibilityTypeEnum.Internal,
  },
]

export const PRODUCT_VISIBILITY_TYPE = [
  {
    label: "Everyone",
    value: VisibilityTypeEnum.Everyone,
    description: "This product can be booked by anyone.",
  },
  {
    label: "Internal Only",
    value: VisibilityTypeEnum.Internal,
    description: "This product can be booked only by staff.",
  },
  {
    label: "For Member",
    value: VisibilityTypeEnum.Member,
    description: "This product can be booked only by members and staff.",
  },
]

export const LocationTypeEnum = {
  REEDEM_POINT: "redeem_point",
  OFFICE: "office",
}

export const LocationTypeOptions = [
  {
    label: "Redeem Point",
    value: LocationTypeEnum.REEDEM_POINT,
  },
  {
    label: "Office",
    value: LocationTypeEnum.OFFICE,
  },
]

export const MerchandizeTypeEnum = {
  Customer: "customer",
  Participant: "participant",
}

export const MERCHANDIZE_ATTACH_TYPES = [
  {
    label: "Per Booking",
    value: MerchandizeTypeEnum.Customer,
  },
  {
    label: "Per Participant",
    value: MerchandizeTypeEnum.Participant,
  },
]

export const AddOnsRequirementsTypeEnum = {
  Add_Optional: "optional",
  Customer_must_select: "required",
}

export const ADD_ONS_REQUIREMENTS = [
  {
    label: "Add-On is optional",
    value: AddOnsRequirementsTypeEnum.Add_Optional,
  },
  {
    label: "Customer must select a choice",
    value: AddOnsRequirementsTypeEnum.Customer_must_select,
  },
]

export const AddOnsTypesEnum = {
  quntity_selection: "quantity_selection",
  dropdown: "dropdown",
  checkbox: "checkbox",
}

export const ADD_ONS_TYPES = [
  {
    label: "Quantity selection",
    value: AddOnsTypesEnum.quntity_selection,
  },
  {
    label: "As a Checkbox",
    value: AddOnsTypesEnum.checkbox,
  },
]

export const SellTypeEnum = {
  Individually: "individually",
  AsSuggestedProduct: "suggested_product",
  asAddOns: "add_on",
}

export const SELL_TYPE = [
  {
    label: "As a Add-ons",
    value: SellTypeEnum.asAddOns,
  },
  // {
  //   label: 'As a Suggested Product',
  //   value: SellTypeEnum.AsSuggestedProduct
  // },
  {
    label: "Individually",
    value: SellTypeEnum.Individually,
  },
]

export const PriceForChannelOptions = [
  {
    label: "Offline",
    description: "This price is available for offline booking.",
  },
  {
    label: "Online",
    description: "This price is available for online booking.",
  },
  {
    label: "Affiliate",
    description: "This price is available for affiliate booking.",
  },
]

export enum closureType {
  CLOSED_INTERNAL_AND_EXTERNAL = "closed-internal-and-external",
  CLOSED_EXTERNAL_AND_OPEN_INTERNAL = "closed-external-and-open-internal",
  CLOSED_EXTERNAL_CALL_TO_BOOK_AND_OPEN_INTERNAL = "closed-external-call-to-book-and-open-internal",
}

export const ClosureTypeOptions = [
  {
    label: "Closed for internal and external",
    value: closureType.CLOSED_INTERNAL_AND_EXTERNAL,
  },
  {
    label: "Closed for external and open for internal",
    value: closureType.CLOSED_EXTERNAL_AND_OPEN_INTERNAL,
  },
  {
    label: "External call to book and open internal",
    value: closureType.CLOSED_EXTERNAL_CALL_TO_BOOK_AND_OPEN_INTERNAL,
  },
]

export const TicketVisibilityTypeEnum = {
  Everyone: "everyone",
  Internal: "internal",
  External: "external",
}

export const TICKET_VISIBILITY = [
  {
    label: "Everyone",
    value: TicketVisibilityTypeEnum?.Everyone,
  },
  {
    label: "Internal",
    value: TicketVisibilityTypeEnum?.Internal,
  },
  {
    label: "External",
    value: TicketVisibilityTypeEnum?.External,
  },
]

export const TICKET_DAYS_CALCULATION = [
  {
    label: "Same day",
    value: true,
  },
  {
    label: "Next day",
    value: false,
  },
]

export const MEMBERSHIP_VERIFICATION_OPTIONS = [
  {
    label: "Email",
    value: SendOtpFieldType.EMAIL,
  },
  // {
  //   label: 'Membership ID/ Customer ID',
  //   value:SendOtpFieldType.MEMBER_CODE
  // }
]

export enum EMenuTitle {
  DASHBOARD = "Dashboard",
  MANIFEST = "Manifest",
  INVENTORY = "Inventory",
  ORDERS = "Orders",
  BOOKINGS = "Bookings",
  CUSTOMERS = "Customers",
  CALENDAR = "Calendar",
  WAIVER = "Waiver",
  AFFILIATES = "Affiliate Management",
  REPORTS = "Reports",
  WIDGETS = "Widgets",
  STAFF_MANAGEMENT = "Staff Management",
  COMMUNICATIONS = "Communications",
  SETTINGS = "Settings",
  MEMBERSHIP = "Membership",
  TICKET_LIMITATIONS = "Ticket Limitations",
}

export const MANIFEST_ACCORDION = "manifest_accordion"
